<template>
  <div id="hotelCouponDay">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>香港广场定制报表</el-breadcrumb-item>
          <el-breadcrumb-item>寰星酒店优惠券日汇总</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间::">
          <el-date-picker v-model="startTime"
                          style="width:200px"
                          type="datetime"
                          :clearable="false"
                          :picker-options="startMonthOption"
                          @change="selectStartMonth"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间::">
          <el-date-picker v-model="endTime"
                          style="width:200px"
                          :clearable="false"
                          type="datetime"
                          :picker-options="endMonthOption"
                          @change="selectEndMonth"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     :loading="loading"
                     @click="query">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="dataList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                stripe
                ref="singleTable">
        <!--<el-table-column type="index"-->
        <!--width="100%"-->
        <!--label="序号">-->
        <!--</el-table-column>-->
        <el-table-column
          v-for="col in cols"
          :prop="col.prop" :label="col.label"  v-bind:key="col.prop">
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import { unionAPI as union } from '../../../api/unionReport'
import { mapActions } from 'vuex'
import * as user from '../../../api/user'
export default {
  name: 'hotelCouponDay.vue',
  data () {
    return {
      is_export: false,
      startTime: '',
      endTime: '',
      dataList: [],
      choiceCusts: [],
      choiceGroups: [],
      selCustID: '',
      selfGroupID: '',
      loading: false,
      export_loading: false,
      tableHeight: 0,
      export_msg: '导出',
      cols: [],
      startMonthOption: {
      },
      endMonthOption: {
      }
    }
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'getCustByGroup', 'getCardGroupByCustId'
    ]),
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 255
      obj.tableHeight = clientHeight
    },
    changeCust (fCustID) {
      // this.selfGroupID = ''
      // this.choiceGroups = []
      // this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
      //   let { status, data } = res
      //   if (status === 200) {
      //     if (data.IsOk) {
      //       let tmpGroups = []
      //       Object.assign(tmpGroups, data.Data)
      //       this.choiceGroups = tmpGroups
      //     }
      //   }
      // })
    },
    getCurrentMonthLast (dt) {
      var date = dt
      var currentMonth = date.getMonth()
      var nextMonth = ++currentMonth
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      var oneDay = 1000 * 60 * 60 * 24
      var lastTime = new Date(nextMonthFirstDay - oneDay)
      var month = parseInt(lastTime.getMonth() + 1)
      var day = lastTime.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return new Date(date.getFullYear() + '-' + month + '-' + day + ' 23:59:59')
    },
    selectStartMonth () {
      var endMonth = this.endTime.getMonth()
      var startMonth = this.startTime.getMonth()
      if (endMonth !== startMonth) {
        this.endTime = this.getCurrentMonthLast(this.startTime)
      }
      this.endMonthOption = {
        disabledDate: (time) => {
          if (this.startTime !== '') {
            var endMonth = this.startTime.getMonth()
            var minMonth = time.getMonth()
            return time.getTime() < this.startTime.getTime() || minMonth !== endMonth
          }
        }
      }
    },
    selectEndMonth () {
      // var endMonth = this.endTime.getMonth()
      // var startMonth = this.startTime.getMonth()
      // if (endMonth !== startMonth) {
      //   var beginDay = this.endTime.getDate()
      //   this.startTime = new Date(this.endTime.getFullYear(), this.endTime.getMonth(), beginDay, 0, 0, 0)
      // }
      // this.startMonthOption = {
      //   disabledDate: (time) => {
      //     if (this.endTime !== '') {
      //       var endMonth = this.endTime.getMonth()
      //       var minMonth = time.getMonth()
      //       return time.getTime() > this.endTime.getTime() || endMonth > minMonth
      //     }
      //   }
      // }
    },
    query () {
      this.initData()
    },
    initData () {
      this.dataList = []
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      var queryParam = {
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        fParkID: 0,
        fStartTime: this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss'),
        fEndTime: this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss'),
        exportData: 0
      }
      union.getCouponDayAsync(queryParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.dataList = data.Data.rows
              this.cols = data.Data.cols
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      var queryParam = {
        fCustID: this.selCustID,
        fGroupID: this.selfGroupID,
        fParkID: 0,
        fStartTime: this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss'),
        fEndTime: this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss'),
        exportData: 1
      }
      union.getCouponDayAsync(queryParam).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_寰星酒店优惠券日汇总.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 886000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    var today = new Date()
    this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
    this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.changeCust(this.selCustID)
            }
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
  .hotelCouponDay .el-form-item {
    margin-bottom: 5px;
  }
</style>
<style scoped>
  .el-form-item {
    margin-bottom: 5px;
  }
  .pagination {
    text-align: right;
    padding-top: 5px;
  }
  .search {
    width: 200px;
  }
  .danger {
    color: #f56c6c;
  }
  .success {
    color: #67c23a;
  }
</style>



// WEBPACK FOOTER //
// src/view/report/unionReport/hotelCouponDay.vue